// Lightweight shared anti-bot utilities for forms
// Provides: random honeypot field name, submission id, and min-time helpers

export const generateSubmissionId = (): string => {
  // Simple UUID v4 generator
  // eslint-disable-next-line
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    const r = (Math.random() * 16) | 0,
      v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
};

export const generateHoneypotName = (prefix: string = 'hp_'): string => {
  const alphabet = 'abcdefghijklmnopqrstuvwxyz0123456789';
  let s = '';
  for (let i = 0; i < 6; i++) s += alphabet[Math.floor(Math.random() * alphabet.length)];
  return `${prefix}${s}`;
};

export type AntiBotBundle = {
  submissionId: string;
  honeypotFieldName: string;
  honeypotValue: string;
  setHoneypotValue: (v: string) => void;
  formOpenedAt: number;
  getMinTimeMs: () => number;
};

export const createAntiBotBundle = (): AntiBotBundle => {
  const submissionId = generateSubmissionId();
  const honeypotFieldName = generateHoneypotName();
  let _honeypotValue = '';
  const formOpenedAt = Date.now();

  return {
    submissionId,
    honeypotFieldName,
    get honeypotValue() {
      return _honeypotValue;
    },
    setHoneypotValue: (v: string) => {
      _honeypotValue = v;
    },
    formOpenedAt,
    getMinTimeMs: () => Date.now() - formOpenedAt,
  } as AntiBotBundle;
};
